import React from 'react';
import cx from 'classnames';
import FollowUsStore from './store';
import wrapStore from '@src/utils/wrap-store';

// const styles = require('./index.less');
const styles = require('./res.less');

/**
 * FollowUs
 * @param store {FollowUsStore}
 * @param className
 * @returns {JSX.Element}
 * @constructor
 */
const FollowUs = ({ store, className }) => {
  store.use();
  const renderList = () => {
    return store.itemList.map((item, key) => {
      return (
        <div
          className={styles.listItem}
          key={key}
          onClick={() => {
            // $$tracker.clickShareSsg(item.name);
            store.onRedirectLink(item.link);
            item.onClick();
          }}
        >
          <div className={styles.itemImg}>
            <img src={item.img} alt={''} />
          </div>
          <div className={styles.itemName}>{item.name}</div>
        </div>
      );
    });
  };
  return (
    <div className={cx(styles.root, className)} id={'followUs'} onMouseEnter={store.handleMouseEnter} onMouseLeave={store.handleMouseLeave}>
      <div className="xfe-group-1" data-name="follow-us">
        <div className={cx('xfe-group-2', store.isActive ? styles.showList : styles.hideList)} data-name="modal">
          {renderList()}
        </div>
        <div className="xfe-layer-20">
          <div className={styles.shareIcon} />
          {/*<div className="down_logo" />*/}
        </div>
        <div className="xfe-layer-21" />
      </div>
    </div>
  );
};

export default wrapStore(FollowUs, FollowUsStore);
